var $e5024b484f7c3e21$exports = {};
$e5024b484f7c3e21$exports = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};


export {$e5024b484f7c3e21$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
